import React, { useState } from "react";
import emailjs from '@emailjs/browser';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    title: "",
    message: ""
  });
  
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      title: formData.title,
      message: formData.message,
    };

    emailjs.send(
      'service_b9uzpeq', 
      'template_yrprrqq', 
      templateParams, 
      'shbwQ8xiHnHuPWpT7'
    )
    .then((response) => {
       alert('Your message was sent successfully.');
       setFormData({ name: "", email: "", title: "", message: "" });
    }, (err) => {
       alert('FAILED... Please try again later.');
       console.log('FAILED...', err);
    })
    .finally(() => {
       setIsSending(false);
    });
  };

  return (
    <div className="contact-wrapper py-5">
  <div className="container">

    <div className="text-center mb-5">
      <h6 className="small-title">Get In Touch</h6>
      <h1 className="main-title">Contact for any query</h1>
    </div>

    <div className="contact-main-box p-4">
      <div className="row g-5 align-items-stretch">

        {/* MAP */}
        <div className="col-lg-6">
          <div className="contact-map-card">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2431.291818952413!2d-1.8415167221740276!3d52.45574227204437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2f972f9cca636889%3A0xd1a43c651689517!2sUnigenius%20Consultants!5e0!3m2!1sen!2sin!4v1769949331079!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              title="Google Map"
            ></iframe>
          </div>
        </div>

        {/* FORM */}
        <div className="col-lg-6">
          <form onSubmit={handleSubmit} className="contact-form-card">

            <div className="input-group-modern">
              <i className="bi bi-person"></i>
              <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required />
            </div>

            <div className="input-group-modern">
              <i className="bi bi-envelope"></i>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" required />
            </div>

            <div className="input-group-modern">
              <i className="bi bi-card-text"></i>
              <input type="text" name="title" value={formData.title} onChange={handleChange} placeholder="Title" required />
            </div>

            <div className="input-group-modern textarea">
              <i className="bi bi-chat-left-text"></i>
              <textarea name="message" value={formData.message} onChange={handleChange} rows="5" placeholder="Message" required />
            </div>

            <button className="send-btn" type="submit" disabled={isSending}>
              {isSending ? "Sending..." : "Send Message"}
            </button>

          </form>
        </div>

      </div>
    </div>
  </div>
</div>

  );
};

export default ContactSection;